/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "products-management",
	data() {
		return {
			products: [],
			productHeadings: [
				{
					text: "#",
					field: "productId"
				},
				{
					text: "Product Code",
					field: "productCode"
				},
				{
					text: "Name",
					field: "name"
				},
				{
					text: "Product Type",
					field: "productTypeName"
				},
				{
					text: "ERP Code",
					field: "erpCode"
				},
				{
					text: "Eligible For Delivery?",
					field: "allowDelivery"
				},
				{
					text: "Eligible For Collection?",
					field: "allowCollection"
				},
				{
					text: "Eligible For Ex-Tank?",
					field: "allowExTank"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Date Created",
					field: "insertedOn"
				}
			],
			productTypes: [],
			productTypesForSelect: [],
			orderTypes: [],
			productType: {},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			productAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditProductModal",
				heading: "Add Product",
				product: {
					productId: null,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					price: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					erpCode: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					productCode:{
						value: null,
						hasError: false,
						errorMessage: null
					},
					effectiveDate: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					productTypeId:{
						value: null,
						hasError: false,
						errorMessage: null
					},
					allowCollection: false,
					allowDelivery: false,
					allowExTank: false,
					allowCollectionDeliveryErrorMessage: null,
					allowCollectionDeliveryHasError: false,
					isActive: true
				},
				isUpdate: false
			},
			productMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markProductAsActiveInactiveModal",
				heading: "Mark Product As Active/Inactive",
				isActive: null,
				productId: null
			},
			filterStateChanged: false,
			filter:{
				productTypeId: null,
				orderTypeId: 0,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getProducts(){
			this.loading = true;
			let allowDelivery = true;
			let allowCollection = true;
			let allowExTank = true;
			if(this.filter.orderTypeId === orderHelper.orderType.delivery){
				allowDelivery = true;
				allowCollection = null;
				allowExTank = null;
			}
			if(this.filter.orderTypeId === orderHelper.orderType.collection){
				allowDelivery = null;
				allowCollection = true;
				allowExTank = null;
			}
			if(this.filter.orderTypeId === orderHelper.orderType.exTank){
				allowDelivery = null;
				allowCollection = null;
				allowExTank = true;
			}
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				allowCollection: allowCollection,
				allowDelivery: allowDelivery,
				allowExTank: allowExTank,
				productTypeId: this.filter.productTypeId,
			};
			productService.getProducts(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.products = successResponse.data.result;
						for(let i = 0; i < this.products.length; i++){
							this.products[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.products[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								}
							];
							//this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].price);
						}
						this.products = dataTableHelper.castFieldValues(this.products);
						this.filterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProductTypes(){
			productService.getProductTypes().then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.productTypes = successResponse.data.result;
						this.productTypesForSelect = JSON.parse(JSON.stringify(this.productTypes));
						this.productTypesForSelect.unshift({
							productTypeId: 0,
							name: "All"
						});
						this.productTypes = $.map(this.productTypes,
							function (obj) {
								obj.id = obj.id || obj.productTypeId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.productTypesForSelect = $.map(this.productTypesForSelect,
							function (obj) {
								obj.id = obj.id || obj.productTypeId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.filter.productTypeId = 0;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderTypes(){
			this.productType = productHelper.productType;
			this.orderTypes = orderService.getOrderTypes();
			this.orderTypes.unshift({
				orderTypeId: 0,
				description: "All"
			});
			this.orderTypes = $.map(this.orderTypes,
				function (obj) {
					obj.id = obj.id || obj.orderTypeId;
					obj.text = obj.text || obj.description;
					return obj;
				});
		},
		generateProductCode(){
			if(this.productAddEditFormModal.product.name.value === null || this.productAddEditFormModal.product.name.value === ""){
				return;
			}
			if(this.productAddEditFormModal.product.productCode.value === null || this.productAddEditFormModal.product.productCode.value === ""){
				let request = {
					productName: this.productAddEditFormModal.product.name.value
				};
				productService.generateProductCode(request).then(
					successResponse => {
						console.log("successResponse", successResponse);
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess){
							//success
							this.productAddEditFormModal.product.productCode.value = successResponse.data.result;
						}
					},
					errorResponse => {
						console.log("errorResponse", errorResponse);
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				);
			}
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getProducts();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onOrderTypeFilterSelect(orderType){
			if(this.filter.orderTypeId !== orderType.id){
				this.filter.orderTypeId = orderType.id;
				this.filterStateChanged = true;
			}
		},
		onProductTypeFilterSelect(productType){
			if(this.filter.productTypeId !== productType.id){
				this.filter.productTypeId = productType.id;
				this.filterStateChanged = true;
			}
		},
		onAddProductClick(){
			this.productAddEditFormModal.heading = "Add Product";
			this.clearProductModel();
			this.productAddEditFormModal.showModal = true;
			this.productAddEditFormModal.isUpdate = false;
		},
		onProductActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.productAddEditFormModal.showModal = true;
					this.productAddEditFormModal.heading = "Edit Product";
					this.productAddEditFormModal.product.productCode.value = actionAndData.data.productCode;
					this.productAddEditFormModal.product.productId = actionAndData.data.productId;
					this.productAddEditFormModal.product.name.value = actionAndData.data.name;
					this.productAddEditFormModal.product.erpCode.value = actionAndData.data.erpCode;
					this.productAddEditFormModal.product.allowCollection = castingUtility.toBoolean(actionAndData.data.allowCollection);
					this.productAddEditFormModal.product.allowDelivery = castingUtility.toBoolean(actionAndData.data.allowDelivery);
					this.productAddEditFormModal.product.allowExTank = castingUtility.toBoolean(actionAndData.data.allowExTank);
					this.productAddEditFormModal.product.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.productAddEditFormModal.product.productTypeId.value = actionAndData.data.productTypeId;
					//this.productAddEditFormModal.product.price.value = actionAndData.data.price;
					this.productAddEditFormModal.isUpdate = true;
					break;
				case this.actionKeys.markAsActiveInactive:
					this.productMarkAsActiveInactiveModal.productId = actionAndData.data.productId;
					this.productMarkAsActiveInactiveModal.showModal = true;
					this.productMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.productMarkAsActiveInactiveModal.heading = "Mark Product As " + (this.productMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.name;
					this.productMarkAsActiveInactiveModal.productId = actionAndData.data.productId;
					break;
			}
		},
		onProductTypeSelect(productType){
			this.productAddEditFormModal.product.productTypeId.value = productType.id;
		},
		onMarkProductActiveInactiveSelected(isActive){
			this.productMarkAsActiveInactiveModal.isActive = isActive;
			console.log("productMarkAsActiveInactiveModal.isActive", this.productMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.productMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				productId: this.productMarkAsActiveInactiveModal.productId,
				isActive: markAsActive
			};
			productService.markProductAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getProducts();
						this.productMarkAsActiveInactiveModal.showModal = false;
						this.productMarkAsActiveInactiveModal.isActive = null;
						this.productMarkAsActiveInactiveModal.productId = null;
					}
					this.productMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.productMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		// onPriceInput(price){
		// 	console.log("price", this.productAddEditFormModal.product.price);
		// 	if (isNaN(this.productAddEditFormModal.product.price)) {
		// 		this.productAddEditFormModal.product.price = "";
		// 	}
		//
		// 	var formatter = new Intl.NumberFormat('en-ZA', {
		// 		style: 'currency',
		// 		currency: 'ZAR',
		// 		minimumFractionDigits: 2
		// 	});
		// 	console.log("formatter", formatter.format(this.productAddEditFormModal.product.price));
		// 	var value = formatter.format(this.productAddEditFormModal.product.price);
		// 	console.log("value", value);
		// 	this.productAddEditFormModal.product.price = value;
		// },
		onAddOrEditProductModalCloseClick(){
			this.productAddEditFormModal.showModal = false;
			this.clearProductModel();
		},
		onNewPriceDateSelect(date){
			this.productAddEditFormModal.product.effectiveDate.value = date;
		},
		onAddOrEditProductSaveClick(){
			this.productAddEditFormModal.isSaving = true;
			let request = {
				productId: this.productAddEditFormModal.product.productId,
				name: this.productAddEditFormModal.product.name.value,
				erpCode: this.productAddEditFormModal.product.erpCode.value,
				allowForCollection: this.productAddEditFormModal.product.allowCollection,
				allowForDelivery: this.productAddEditFormModal.product.allowDelivery,
				allowForExTank: this.productAddEditFormModal.product.allowExTank,
				//price: this.productAddEditFormModal.product.price.value,
				isActive: this.productAddEditFormModal.product.isActive,
				productCode: this.productAddEditFormModal.product.productCode.value,
				productTypeId: this.productAddEditFormModal.product.productTypeId.value === null ? 0 : this.productAddEditFormModal.product.productTypeId.value,
			};
			console.log("request", request);
			productService.addOrUpdateProduct(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.productValidationResponse.valuesAreValid){
							this.productAddEditFormModal.showModal = false;
							this.clearProductModel();
							this.getProducts();
						}
						else{
							this.productAddEditFormModal.product.name.hasError = successResponse.data.productValidationResponse.nameValidationResponse.hasError;
							this.productAddEditFormModal.product.name.errorMessage = successResponse.data.productValidationResponse.nameValidationResponse.message;

							// this.productAddEditFormModal.product.price.hasError = successResponse.data.productValidationResponse.priceValidationResponse.hasError;
							// this.productAddEditFormModal.product.price.errorMessage = successResponse.data.productValidationResponse.priceValidationResponse.message;

							// this.productAddEditFormModal.product.effectiveDate.hasError = successResponse.data.productValidationResponse.effectiveDateResponse.hasError;
							// this.productAddEditFormModal.product.effectiveDate.errorMessage = successResponse.data.productValidationResponse.effectiveDateResponse.message;
							
							this.productAddEditFormModal.product.allowCollectionDeliveryHasError = successResponse.data.productValidationResponse.enableCollectionOrdersOrDeliveryOrdersValidationResponse.hasError;
							this.productAddEditFormModal.product.allowCollectionDeliveryErrorMessage = successResponse.data.productValidationResponse.enableCollectionOrdersOrDeliveryOrdersValidationResponse.message;
						
							this.productAddEditFormModal.product.productTypeId.hasError = successResponse.data.productValidationResponse.productTypeValidationResponse.hasError;
							this.productAddEditFormModal.product.productTypeId.errorMessage = successResponse.data.productValidationResponse.productTypeValidationResponse.message;
						}
					}
					this.productAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.productAddEditFormModal.isSaving = false;
					alert("Unexpected error occurred");
				}
			);
		},
		clearProductModel(){
			this.productAddEditFormModal.product = {
				productId: null,
				name: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				price: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				productCode: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				erpCode: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				effectiveDate: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				productTypeId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				allowCollection: false,
				allowDelivery: false,
				allowCollectionDeliveryErrorMessage: null,
				allowCollectionDeliveryHasError: false,
				isActive: true
			};	
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Products");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Products"
			};
			// var driverManagementBreadcrumb = {
			// 	url: this.$route.path,
			// 	displayText: "Products"
			// };
			breadcrumbs.push(breadcrumbLogistics);
			//breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getProductTypes();
		this.getProducts();
		this.getOrderTypes();
	}
};